/**
 * @generated SignedSource<<03ac623fc1b9a207f6465549a3bccf93>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useHydratedValues_cascadeSelectPicker$data = {
  readonly jira?: {
    readonly jqlBuilder: {
      readonly hydrateJqlQuery?: {
        readonly fields?: ReadonlyArray<{
          readonly jqlTerm?: string;
          readonly values?: ReadonlyArray<{
            readonly __typename: "JiraJqlQueryHydratedError";
            readonly jqlTerm: string;
          } | {
            readonly __typename: "JiraJqlQueryHydratedValue";
            readonly jqlTerm: string;
            readonly values: ReadonlyArray<{
              readonly __typename: "JiraJqlCascadingOptionFieldValue";
              readonly displayName: string;
              readonly jqlTerm: string;
              readonly optionId: string | null | undefined;
              readonly parentOption: {
                readonly displayName: string;
                readonly jqlTerm: string;
                readonly optionId: string | null | undefined;
              } | null | undefined;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            } | null | undefined>;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null | undefined>;
        }>;
      } | null | undefined;
      readonly hydrateJqlQueryForFilter?: {
        readonly fields?: ReadonlyArray<{
          readonly jqlTerm?: string;
          readonly values?: ReadonlyArray<{
            readonly __typename: "JiraJqlQueryHydratedError";
            readonly jqlTerm: string;
          } | {
            readonly __typename: "JiraJqlQueryHydratedValue";
            readonly jqlTerm: string;
            readonly values: ReadonlyArray<{
              readonly __typename: "JiraJqlCascadingOptionFieldValue";
              readonly displayName: string;
              readonly jqlTerm: string;
              readonly optionId: string | null | undefined;
              readonly parentOption: {
                readonly displayName: string;
                readonly jqlTerm: string;
                readonly optionId: string | null | undefined;
              } | null | undefined;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            } | null | undefined>;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null | undefined>;
        }>;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useHydratedValues_cascadeSelectPicker";
};
export type useHydratedValues_cascadeSelectPicker$key = {
  readonly " $data"?: useHydratedValues_cascadeSelectPicker$data;
  readonly " $fragmentSpreads": FragmentRefs<"useHydratedValues_cascadeSelectPicker">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "scope",
  "variableName": "scope"
},
v1 = {
  "kind": "Variable",
  "name": "viewContext",
  "variableName": "viewContext"
},
v2 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v5 = {
  "kind": "ScalarField",
  "name": "optionId"
},
v6 = [
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "kind": "LinkedField",
        "name": "fields",
        "plural": true,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "kind": "LinkedField",
                "name": "values",
                "plural": true,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      (v2/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "values",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v3/*: any*/),
                              (v2/*: any*/),
                              (v4/*: any*/),
                              (v5/*: any*/),
                              {
                                "concreteType": "JiraJqlCascadingOptionFieldValue",
                                "kind": "LinkedField",
                                "name": "parentOption",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v2/*: any*/),
                                  (v5/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraJqlCascadingOptionFieldValue"
                          }
                        ]
                      }
                    ],
                    "type": "JiraJqlQueryHydratedValue"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      (v2/*: any*/)
                    ],
                    "type": "JiraJqlQueryHydratedError"
                  }
                ]
              }
            ],
            "type": "JiraJqlQueryHydratedField"
          }
        ]
      }
    ],
    "type": "JiraJqlHydratedQuery"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "filterAri"
    },
    {
      "kind": "RootArgument",
      "name": "includeJira"
    },
    {
      "kind": "RootArgument",
      "name": "isFilter"
    },
    {
      "kind": "RootArgument",
      "name": "jql"
    },
    {
      "kind": "RootArgument",
      "name": "scope"
    },
    {
      "kind": "RootArgument",
      "name": "viewContext"
    }
  ],
  "kind": "Fragment",
  "name": "useHydratedValues_cascadeSelectPicker",
  "selections": [
    {
      "condition": "includeJira",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "cloudId",
                  "variableName": "cloudId"
                }
              ],
              "concreteType": "JiraJqlBuilder",
              "kind": "LinkedField",
              "name": "jqlBuilder",
              "plural": false,
              "selections": [
                {
                  "condition": "isFilter",
                  "kind": "Condition",
                  "passingValue": false,
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "query",
                          "variableName": "jql"
                        },
                        (v0/*: any*/),
                        (v1/*: any*/)
                      ],
                      "kind": "LinkedField",
                      "name": "hydrateJqlQuery",
                      "plural": false,
                      "selections": (v6/*: any*/)
                    }
                  ]
                },
                {
                  "condition": "isFilter",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "id",
                          "variableName": "filterAri"
                        },
                        (v0/*: any*/),
                        (v1/*: any*/)
                      ],
                      "kind": "LinkedField",
                      "name": "hydrateJqlQueryForFilter",
                      "plural": false,
                      "selections": (v6/*: any*/)
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "92d338efa13872bf45e89b5f9f1155af";

export default node;
